import React from "react";
import {
  InformationBanner,
  WarningBanner,
} from "@graffer-inc/console-design-kit";

import { PublishStatus } from "../../../../application/domain/procedures/procedure-entity";
import { useModal } from "../../../../utils/custom-hooks";
import { BaseModal } from "../../../atoms/base-modal";
import { ProcMasterModal } from "./proc-master-modal";

export const ProcMasterNotification: React.FC<{
  orgId: string;
  groupIds?: string[];
  status: PublishStatus;
  onUpdateProcMaster: (procMstId: string) => Promise<void>;
  disabled?: boolean;
}> = ({ orgId, groupIds, status, onUpdateProcMaster, disabled = false }) => {
  const procMasterModal = useModal();
  const isWarning = status === "ACCEPTING";
  return (
    <>
      {!disabled && isWarning && (
        <WarningBanner message="この手続きの申請開始ページのリンクは手続きマスタに掲載されていません" />
      )}
      {!disabled && !isWarning && (
        <InformationBanner message="この手続きの申請開始ページのリンクは手続きマスタに掲載されていません" />
      )}
      <div className="is-size-7 mt-2">
        <button
          onClick={procMasterModal.open}
          className="button is-small"
          disabled={disabled}
        >
          掲載する手続きマスタを選択する
        </button>
      </div>
      <BaseModal
        isActive={procMasterModal.isActive}
        title="リンクを掲載する手続きマスタの選択"
        onClose={procMasterModal.close}
        hasOverflow={true}
      >
        <ProcMasterModal
          orgId={orgId}
          groupIds={groupIds}
          onUpdateProcMaster={onUpdateProcMaster}
          onClose={procMasterModal.close}
        />
      </BaseModal>
    </>
  );
};
